import React, { forwardRef, useState } from 'react'
import styled from 'styled-components'

import { Feedback } from '../DesignSystem/Inputs/InputWrapperBase'

const ValidationMessage = (props) => {
  if (props.error && props.touched) {
    return (
      <Feedback id="validation-error" className="field-error" error>
        {props.icon ?? props.icon}
        {props.error}
      </Feedback>
    )
  }

  if (props.hint && !props.error) {
    return (
      <Feedback disabled={props.disabled} id={`${props.id}_hint`}>
        {props.icon ?? props.icon}
        {props.hint}
      </Feedback>
    )
  }
  return null
}

const FieldContainer = styled.div`
  position: relative;
  padding-bottom: 18px;
`

const withValidation = (InputComponent) =>
  forwardRef((props, ref) => {
    const [showFeedback, setShowFeedback] = useState(true)

    // Check if this is a redux-form Field by looking for input prop, fixed for movining cursor position to the end of the input
    const shouldPreserveCursorPosition = Boolean(props.input)

    return (
      <FieldContainer className="withValidation__container" id={`${props.id}_container`}>
        <InputComponent
          {...props}
          {...props.input}
          {...props.selectProps}
          ref={ref}
          placeholder={props.placeholder}
          autoFocus={props.autoFocus}
          onRemove={() => setShowFeedback(false)}
          preserveCursorPosition={shouldPreserveCursorPosition}
        />
        {showFeedback && <ValidationMessage {...props.meta} disabled={props.disabled} />}
      </FieldContainer>
    )
  })

export default withValidation
